import { Pipe, PipeTransform } from '@angular/core';

interface IObject {
  [key: string]: string;
}

@Pipe({
  name: 'isCheckedElement',
})
export class IsCheckedElementPipe implements PipeTransform {
  transform(item: IObject, arr: IObject[], propsName: string): boolean {
    if (arr && arr.length && propsName) {
      return arr.some((el) => el[propsName] === item[propsName]);
    }
    return null;
  }
}
